import { formatDetailDateTime, formatPropertyPrice } from "../../../utils/propertyDetailFormat";

function formatEventDetail(event, currency) {
  const parts = [];

  if (event.newPriceMin != null) {
    parts.push(formatPropertyPrice(event.newPriceMin, event.currency || currency));
  }

  if (event.newAvailabilityStatus) {
    parts.push(event.newAvailabilityStatus.replace(/_/g, " ").toLowerCase());
  }

  if (event.priceChangePercent != null) {
    parts.push(`${event.priceChangePercent > 0 ? "+" : ""}${event.priceChangePercent}%`);
  }

  return parts.join(" · ");
}

const PropertyHistoryTimeline = ({ listingHistory = [], currency = "COP" }) => {
  if (!listingHistory.length) {
    return (
      <section className="property-detail-section" aria-label="Listing history">
        <h2 className="property-detail-section__title">Listing history</h2>
        <p className="property-detail-empty">
          No historical changes have been recorded yet.
        </p>
      </section>
    );
  }

  return (
    <section className="property-detail-section" aria-label="Listing history">
      <h2 className="property-detail-section__title">Listing history</h2>
      <ol className="property-detail-timeline">
        {listingHistory.map((event) => {
          const detail = formatEventDetail(event, currency);
          const changeClass =
            event.changeType === "PRICE_DECREASED"
              ? "decrease"
              : event.changeType === "PRICE_INCREASED"
                ? "increase"
                : "neutral";

          return (
            <li key={`${event.id || event.changedAt}-${event.changeType}`}>
              <div className="property-detail-timeline__marker" aria-hidden="true" />
              <div className="property-detail-timeline__body">
                <p className={`property-detail-timeline__title property-detail-timeline__title--${changeClass}`}>
                  {event.label || event.changeType}
                </p>
                <p className="property-detail-timeline__meta">
                  {formatDetailDateTime(event.changedAt)}
                  {detail ? ` · ${detail}` : ""}
                </p>
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
};

export default PropertyHistoryTimeline;
